import { createRouteRef } from '@backstage/frontend-plugin-api';

/** The « Tâches » page. */
export const tasksRouteRef = createRouteRef();

/** Its path. */
export const TASKS_PATH = '/taches';
